import ApplicationController from "../turbo/application_controller";

export default class extends ApplicationController {
    static targets = [
        "typeSelect", "priceChangeType", "setPriceLevel", "setPrice", "increasePriceLevel",
        "decreasePriceLevel", "increasePriceAmount", "decreasePriceAmount",
        "increasePricePercentage", "decreasePricePercentage"
    ];

    connect() {
        // Selectize.js doesn't use native events so we can't use a stimulus action to
        // listen for the change event.
        $(this.typeSelectTarget).on("change", (event) => {
            this.changeType(event.target.value);
        });
    }

    changeType(type) {
        this.priceChangeTypeTargets.forEach((priceChangeType) => {
            if (priceChangeType === this[type + "Target"]) {
                priceChangeType.classList.remove("hidden");
                priceChangeType.disabled = false;
            } else {
                priceChangeType.classList.add("hidden");
                priceChangeType.disabled = true;
            }
        });
    }
}
